import { FC } from 'react';
import ReviewAggregate from '../ReviewAggregate';
import styles from './ReviewAndAppLinks.module.scss';
import AppLinks from '../AppLinks';

const ReviewAndAppLinks: FC = () => (
  <div className={styles.root}>
    <ReviewAggregate />
    <AppLinks classNameModifier="mobileAppsPage" />
  </div>
);

export default ReviewAndAppLinks;
